import { IStyleableComponentProps, ITestableComponent } from "components/shared-ui/common/component-props";
import React from "react";
import { connect } from "react-redux";
import { IAppState } from "redux/reducers";
import styles from './backdrop.module.scss';
import clsx from "clsx";

interface IBackdropProps
  extends IStyleableComponentProps,
    ITestableComponent,
    ReturnType<typeof mapStateToProps>
    {
}


function Backdrop(props: IBackdropProps) {
     return <div className={clsx(styles.backdrop, props.open ? styles["backdrop-blur"] : styles["backdrop"])} />
}


const mapStateToProps = (state: IAppState) => ({
    open: state.tooltipUserGuide.open,
    tooltipUserGuideEntity: state.tooltipUserGuide.currentEntity,
  });
  
export default connect(mapStateToProps, null)(Backdrop);